export const handleResponseError = (error: {
    response: { data: { message: any } }
  }) => {
    // console.log('error', error?.response?.data?.message)
    if (error?.response?.data) {
      throw error.response.data
    }
    throw error
  }

  /**
   * backend คืน HTTP 200 แม้ทำไม่สำเร็จ ({ status: "failed", error_message, error_data })
   * → โยน body ออกไปแบบเดียวกับ handleResponseError ให้ caller เข้า onError ได้
   */
  export const throwIfFailed = <T>(body: T): T => {
    if ((body as any)?.status === 'failed') throw body
    return body
  }

  /** backend ไม่รองรับชื่อไฟล์ภาษาไทย — เปลี่ยนเป็น timestamp + นามสกุล ASCII เท่านั้น */
  export const renameUploadFileName = (fileName: string): string => {
    const dotIndex = fileName.lastIndexOf('.')
    const rawExtension = dotIndex >= 0 ? fileName.slice(dotIndex + 1) : ''
    const fileExtension = rawExtension.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()
    return fileExtension ? `${Date.now()}.${fileExtension}` : `${Date.now()}`
  }

  export const renameUploadFile = (file: File): File => {
    const newFileName = renameUploadFileName(file.name)
    return new File([file], newFileName, { type: file.type })
  }


  // generate a random string of 6 digits
  export const generateRandomString = () => {
    return Math.floor(100000 + Math.random() * 900000).toString()
  }

  export function move(arr: [], old_index: number, new_index: number) {
    while (old_index < 0) {
      old_index += arr.length
    }
    while (new_index < 0) {
      new_index += arr.length
    }
    if (new_index >= arr.length) {
      var k = new_index - arr.length
      while (k-- + 1) {
        arr.push()
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0])
    return arr
  }
  